import React from 'react';
import Icon from './Icon';

const PlannedIcon = (props) => (
    <Icon {...props}>
        <path
            d="M12 8V12L15 14M9.5 2.4A10 10 0 1 1 2.4 9.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default PlannedIcon;
